"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientOptions = void 0;
var ClientOptions = /** @class */ (function () {
    function ClientOptions(credentials, contentType, requestParameters) {
        if (contentType === void 0) { contentType = "application/json"; }
        this.credentials = credentials;
        this.contentType = contentType;
        this.requestParameters = requestParameters;
    }
    ClientOptions.prototype.withContentType = function (contentType) {
        return new ClientOptions(this.credentials, contentType, this.requestParameters);
    };
    ClientOptions.prototype.withRequestParameters = function (requestParameters) {
        return new ClientOptions(this.credentials, this.contentType, requestParameters);
    };
    return ClientOptions;
}());
exports.ClientOptions = ClientOptions;
//# sourceMappingURL=ClientOptions.js.map